/* ============================================================
   Cloud Store · Cart JS (Vague 3)
   Drawer open/close, qty change AJAX, line remove, variant swap,
   shipping bar live update, cross-sell fetch.
   ============================================================ */
(function () {
  if (window.__csCartInit) return;
  window.__csCartInit = true;

  const SHIPPING_THRESHOLD = parseInt(window.__csCartConfig?.threshold || 5000, 10);
  const BOOST_COLLECTION_HANDLE = window.__csCartConfig?.boostHandle || 'boosters-livraison';

  // ---------- Drawer open/close ----------
  const drawer = document.querySelector('[data-cs-cart-drawer]');
  const backdrop = document.querySelector('[data-cs-cart-backdrop]');

  function openDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    if (backdrop) backdrop.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    reloadDrawerHTML();
    const firstFocus = drawer.querySelector('[data-cs-cart-focus]') || drawer.querySelector('.cs-cart-drawer__body button, .cs-cart-drawer__body a');
    if (firstFocus) firstFocus.focus();
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    if (backdrop) backdrop.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-cs-cart-trigger]');
    if (trigger) {
      e.preventDefault();
      openDrawer();
    }
    const close = e.target.closest('[data-cs-cart-close]');
    if (close) {
      e.preventDefault();
      closeDrawer();
    }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer?.getAttribute('aria-hidden') === 'false') {
      closeDrawer();
    }
  });
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  // Bottom sheet swipe-to-close (mobile)
  let touchStartY = 0;
  let touchDeltaY = 0;
  if (drawer) {
    drawer.addEventListener('touchstart', (e) => {
      if (window.innerWidth >= 768) return;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    drawer.addEventListener('touchmove', (e) => {
      if (window.innerWidth >= 768) return;
      touchDeltaY = e.touches[0].clientY - touchStartY;
      if (touchDeltaY > 0 && drawer.scrollTop === 0) {
        drawer.style.transform = `translateY(${touchDeltaY}px)`;
      }
    }, { passive: true });
    drawer.addEventListener('touchend', () => {
      if (window.innerWidth >= 768) return;
      drawer.style.transform = '';
      if (touchDeltaY > 60) closeDrawer();
      touchDeltaY = 0;
    });
  }

  // Auto-open on cart:added
  document.addEventListener('cart:added', () => {
    openDrawer();
  });

  // ---------- Cart fetch + UI render ----------
  async function refetchCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      const cart = await res.json();
      window.__csCartState = cart;
      updateShippingBar(cart);
      updateCashbackEstimate(cart);
      updateCount(cart);
      updateCrossSellBoost(cart);
      document.dispatchEvent(new CustomEvent('cs:cart:loaded', { detail: cart }));
      return cart;
    } catch (err) {
      console.error('[cs-cart] refetch failed', err);
    }
  }

  function updateShippingBar(cart) {
    document.querySelectorAll('[data-cs-shipbar2]').forEach((bar) => {
      const text = bar.querySelector('[data-cs-shipbar2-text]');
      const fill = bar.querySelector('[data-cs-shipbar2-fill]');
      const total = cart.total_price;
      if (total >= SHIPPING_THRESHOLD) {
        bar.classList.add('is-unlocked');
        if (text) text.textContent = '🎉 Livraison offerte débloquée !';
        if (fill) fill.style.width = '100%';
      } else {
        bar.classList.remove('is-unlocked');
        const remaining = (SHIPPING_THRESHOLD - total) / 100;
        if (text) text.textContent = `Plus que ${remaining.toFixed(2).replace('.', ',')} € pour la livraison offerte 🚚`;
        if (fill) fill.style.width = `${(total / SHIPPING_THRESHOLD * 100).toFixed(1)}%`;
      }
    });
  }

  function updateCashbackEstimate(cart) {
    document.querySelectorAll('[data-cs-cashback-points]').forEach((el) => {
      const points = Math.floor(cart.total_price / 100);
      el.textContent = points;
    });
    document.querySelectorAll('[data-cs-cashback-euros]').forEach((el) => {
      const points = Math.floor(cart.total_price / 100);
      const euros = (points / 20).toFixed(2).replace('.', ',');
      el.textContent = euros;
    });
    document.querySelectorAll('[data-cs-cashback-block]').forEach((el) => {
      el.style.display = cart.total_price < 100 ? 'none' : '';
    });
  }

  function updateCount(cart) {
    document.querySelectorAll('[data-cs-cart-count]').forEach((el) => {
      el.textContent = cart.item_count || 0;
    });
  }

  // ---------- Line item interactions ----------
  document.addEventListener('click', async (e) => {
    const removeBtn = e.target.closest('[data-cs-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const line = removeBtn.closest('.cs-cart-line');
      const key = removeBtn.dataset.csCartRemove;
      if (line) line.classList.add('is-removing');
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      reloadDrawerHTML();
    }
  });

  // Qty +/- buttons
  document.addEventListener('click', async (e) => {
    const minus = e.target.closest('[data-cs-cart-qty-minus]');
    const plus = e.target.closest('[data-cs-cart-qty-plus]');
    if (!minus && !plus) return;
    e.preventDefault();
    const wrap = (minus || plus).closest('.cs-cart-line__qty');
    const input = wrap.querySelector('input');
    const key = input.dataset.csCartLineKey;
    let qty = parseInt(input.value, 10) || 1;
    qty = minus ? Math.max(0, qty - 1) : qty + 1;
    input.value = qty;
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    });
    reloadDrawerHTML();
  });

  // Variant swap (grams pills)
  const swapInFlight = new Set();
  document.addEventListener('click', async (e) => {
    const pill = e.target.closest('[data-cs-cart-line-pill]');
    if (!pill) return;
    e.preventDefault();
    const newId = pill.dataset.csCartLinePill;
    const oldKey = pill.dataset.csCartLineOld;
    const oldQty = parseInt(pill.dataset.csCartLineQty || '1', 10);
    if (swapInFlight.has(oldKey)) return; // guard against rapid double-click
    swapInFlight.add(oldKey);
    pill.disabled = true;
    try {
      // Remove old, add new (Shopify cart has no atomic swap)
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: 0 }),
      });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(newId, 10), quantity: oldQty }] }),
      });
      reloadDrawerHTML();
    } finally {
      swapInFlight.delete(oldKey);
      pill.disabled = false;
    }
  });

  // Variant swap (mobile select)
  document.addEventListener('change', async (e) => {
    const sel = e.target.closest('[data-cs-cart-line-select]');
    if (!sel) return;
    const newId = sel.value;
    const oldKey = sel.dataset.csCartLineOld;
    const oldQty = parseInt(sel.dataset.csCartLineQty || '1', 10);
    if (swapInFlight.has(oldKey)) return;
    swapInFlight.add(oldKey);
    sel.disabled = true;
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: oldKey, quantity: 0 }),
      });
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(newId, 10), quantity: oldQty }] }),
      });
      reloadDrawerHTML();
    } finally {
      swapInFlight.delete(oldKey);
      sel.disabled = false;
    }
  });

  // ---------- Reload drawer markup ----------
  async function reloadDrawerHTML() {
    if (!drawer) {
      // On cart page, just refetch and dispatch event for full re-render
      refetchCart();
      document.dispatchEvent(new CustomEvent('cs:cart:reload-needed'));
      return;
    }
    try {
      const res = await fetch('/?sections=cs-cart-drawer', { headers: { Accept: 'application/json' } });
      const data = await res.json();
      const html = data['cs-cart-drawer'] || '';
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      const fresh = tmp.querySelector('[data-cs-cart-drawer-content]');
      const target = drawer.querySelector('[data-cs-cart-drawer-content]');
      if (fresh && target) {
        target.innerHTML = fresh.innerHTML;
      }
      refetchCart();
    } catch (err) {
      console.error('[cs-cart] reload html failed', err);
      refetchCart();
    }
  }

  // ---------- Cross-sell boost (Zone 1 dynamic) ----------
  async function updateCrossSellBoost(cart) {
    const wrap = document.querySelector('[data-cs-xsell-boost]');
    if (!wrap) return;
    if (cart.total_price >= SHIPPING_THRESHOLD || cart.item_count === 0) {
      wrap.style.display = 'none';
      return;
    }
    wrap.style.display = '';
    // Headline removed — shipping bar above already announces the threshold
  }

  // ---------- Cross-sell add ----------
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cs-xsell-add]');
    if (!btn) return;
    e.preventDefault();
    const variantId = parseInt(btn.dataset.csXsellAdd, 10);
    btn.disabled = true;
    btn.textContent = '…';
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] }),
      });
      btn.textContent = '✓';
      reloadDrawerHTML();
      setTimeout(() => {
        btn.textContent = '+';
        btn.disabled = false;
      }, 1200);
    } catch (err) {
      btn.textContent = '!';
      btn.disabled = false;
      console.error('[cs-xsell] add failed', err);
    }
  });

  // ---------- Patch global fetch to detect cart mutations ----------
  const origFetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : input.url;
    const promise = origFetch.apply(this, arguments);
    if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
      promise.then(() => setTimeout(refetchCart, 80));
    }
    return promise;
  };

  // ---------- Init on load ----------
  document.addEventListener('DOMContentLoaded', () => {
    refetchCart();
  });

  // Cart page event reaction
  document.addEventListener('cs:cart:reload-needed', () => {
    if (!drawer) {
      // We're on cart page — full reload to refresh server-rendered Liquid
      window.location.reload();
    }
  });

  // Listen to legacy cart events from other Sense scripts — reload drawer body if open
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:added', 'cart:item:added'].forEach((evt) => {
    document.addEventListener(evt, () => setTimeout(() => {
      if (drawer && drawer.getAttribute('aria-hidden') === 'false') {
        reloadDrawerHTML();
      } else {
        refetchCart();
      }
    }, 60));
  });
})();
